import { gql } from '@apollo/client';

import { mediaListItemFragment } from '../fragments';

export default gql`
  mutation CreateMediaItem(
    $courseId: String!
    $subjectId: String!
    $input: CreateMediaItemInput!
  ) {
    mediaItem(courseId: $courseId, subjectId: $subjectId, input: $input)
      @rest(
        type: "MediaItem"
        path: "courses/{args.courseId}/subjects/{args.subjectId}/videos"
        method: "POST"
      ) {
      ...MediaListItem
    }
  }
  ${mediaListItemFragment}
`;
